import React from "react";
import { Trash2 } from "lucide-react";
import { usd } from "../../lib/api";
import { RegStatusBadge, fmtUtc } from "./AdminShared";

function ParticipantDetail({ p }) {
  return (
    <div className="rounded-xl bg-[#F2F8F5] p-3">
      <div className="font-semibold text-[#03281B]">{p.first_name} {p.last_name} <span className="text-xs text-slate-400">({p.gender}, DOB {p.dob})</span></div>
      <div className="text-xs text-slate-500">Kit: T {p.tshirt_size} / Shorts {p.shorts_size} / Socks {p.socks_size}</div>
      {p.medical && !p.medical.none && <div className="text-xs text-red-600 mt-1">Medical: {p.medical.details}</div>}
      {(p.items || []).map((it) => <div key={it.label} className="flex justify-between text-xs mt-1"><span>{it.label} - {it.detail}</span><span>{usd(it.amount)}</span></div>)}
    </div>
  );
}

export function RegistrationDetailModal({ selected, onClose, onConfirm, onCancel, onDelete }) {
  const status = selected.registration_status;
  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50" onClick={onClose}>
      <div className="bg-white rounded-2xl max-w-2xl w-full max-h-[85vh] overflow-y-auto p-6" onClick={(e) => e.stopPropagation()} data-testid="reg-detail-modal">
        <div className="flex items-center justify-between">
          <div><div className="font-mono font-bold text-xl text-[#03281B]">{selected.reference}</div><div className="text-sm text-slate-500">{selected.created_at?.slice(0, 10)} &middot; {selected.payment_method === "stripe" ? "Credit Card" : "Bank Transfer"}</div></div>
          <RegStatusBadge status={status} large />
        </div>
        <div className="mt-4 text-sm"><strong>Guardian:</strong> {selected.guardian.first_name} {selected.guardian.last_name} &middot; {selected.guardian.email} &middot; {selected.guardian.phone}</div>
        <div data-testid="reg-terms-accepted" className="mt-1 text-xs text-slate-400">Terms &amp; Privacy accepted: {fmtUtc(selected.terms_accepted_at)}</div>
        <div data-testid="reg-detail-referral" className="mt-1 text-sm"><strong>Referral:</strong> {selected.referral_code ? `${selected.referral_code} (${selected.referral_partner})` : "None"}</div>
        <div className="mt-4 space-y-3">
          {selected.participants.map((p) => <ParticipantDetail key={`${p.first_name}-${p.last_name}-${p.dob}`} p={p} />)}
        </div>
        <div className="flex justify-between font-bold text-lg mt-4 border-t pt-3"><span>Total</span><span>{usd(selected.total)}</span></div>
        <div className="flex gap-3 mt-6">
          {status === "pending_payment" && <button data-testid="confirm-payment-btn" onClick={() => onConfirm(selected.reference)} className="flex-1 rounded-full bg-[#008057] text-white py-2.5 font-bold">Confirm Payment</button>}
          {status !== "cancelled" && <button data-testid="cancel-reg-btn" onClick={() => onCancel(selected.reference)} className="flex-1 rounded-full border-2 border-red-300 text-red-600 py-2.5 font-bold">Cancel Registration</button>}
          <button data-testid="delete-reg-btn" onClick={() => onDelete(selected.reference)} className="rounded-full bg-red-600 hover:bg-red-700 text-white px-5 py-2.5 font-bold flex items-center gap-2"><Trash2 size={16} /> Delete</button>
          <button data-testid="close-reg-modal" onClick={onClose} className="rounded-full border-2 border-[#E2EBF0] text-slate-600 px-6 py-2.5 font-bold">Close</button>
        </div>
      </div>
    </div>
  );
}
